/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {SerialParsedData} from "./SerialParsedData";
import {FeatureBuyData, ISerialData, ISerialInitData, ISymbolValues} from "./ISerialData";
import {SerialDataParser} from "./SerialDataParser";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {SerialGameMode} from "../SerialGameMode";

export class SerialParsedInitData extends SerialParsedData {

    public readonly symbolValues:ISymbolValues;
    public readonly isRestoreState:boolean;
    public readonly featureBuyTimesBetValue:FeatureBuyData[];

    constructor(rawData:ISerialInitData, parser:SerialDataParser) {
        super(rawData, parser);

        this.symbolValues = rawData.symbolValues;
        this.isRestoreState = rawData.isRestoreState;
        this.featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
    }

    public parseScatterPositions(rawData:ISerialData):number[] {
        const result = ArrayHelper.initArrayWithValues(5, reelId => -1);
        if(rawData.mode === SerialGameMode.CAPWIN_GAME) {
            return result;
        }
        for(let reelId = 1; reelId < 4; reelId++) {
            for(let symId = 1; symId < 4; symId++) {
                if(rawData.reels[reelId][symId].includes("S1")) {
                    if(result[reelId] === -1) {
                        result[reelId] = symId + 1;
                    } else {
                        debugger;
                        throw new Error(`Server gives more than 1 Scatter on reel ${reelId}!`);
                        // https://github.com/nolimitcity/tombstonerip/issues/393
                        // rawData.reels[reelId][symId] = this.findLowNoWinSymbol(rawData.reels[0])
                    }
                }
            }
        }
        for(let symId = 1; symId < 4; symId++) {
            if(rawData.reels[4][symId].includes("S2")) {
                if(result[4] === -1) {
                    result[4] = symId + 1;
                } else {
                    debugger;
                    throw new Error(`Server gives more than 1 Scatter on reel ${4}!`);
                    // https://github.com/nolimitcity/tombstonerip/issues/393
                    // rawData.reels[reelId][symId] = this.findLowNoWinSymbol(rawData.reels[0])
                }
            }
        }

        return result;
    }
}